// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): toggleMerchant/toggleWorkshop
// repetían la misma lógica de alternar un id dentro de un arreglo en
// BenefitsScreen.tsx y RewardsScreen.tsx. Extracción sin cambio de
// comportamiento.
export function toggleIdInList(list: readonly string[], id: string): string[] {
  return list.includes(id)
    ? list.filter((entry) => entry !== id)
    : [...list, id];
}
